import {profileType, serviceSectionType} from "../../types/types";

export interface ServiceItemVO {
  name: string;
  sectionId?: string;
  description?: string;
  profile: profileType;
  icon: string;
  link: string;
  id: serviceSectionType;
  callback?: Function;
}

export const SERVICE_ITEMS: ServiceItemVO[]  =
  [
    {
      name: 'Farmacie di turno',
      sectionId: 'Servizi',
      icon: 'local_hospital',
      profile: 'all',
      link: 'pharmacies',
      id: 'pharms'
    },
    {
      name: 'Calendario_rifiuti',
      sectionId: 'Servizi',
      profile: 'cittadino',
      icon: 'recycling',
      link: 'parcheggi',
      id: 'waste'
    },
    {
      name: 'Strisce blu',
      sectionId: 'Servizi',
      profile: 'all',
      icon: 'directions_car',
      link: 'template-detail/code/PARCHEGGI',
      id: 'parcheggi'
    },
    {
      name: 'Avvisi pubblici',
      profile: 'cittadino',
      sectionId: 'Servizi',
      icon: 'campaign',
      link: 'tabs/events',
      id: 'avvisi-pubblici'
    },
    {
      name: 'Trasporti pubblici',
      profile: 'all',
      sectionId: 'Servizi',
      icon: 'directions_bus',
      link: 'transports',
      id: 'trasporti-pubblici'
    },
    /*  {
        name: 'Viaggi_organizzati',
        icon: 'luggage',
        link: 'events/travels',
        id: 'turismo'
      },*/
    {
      name: 'News',
      icon: 'newspaper',
      profile: 'all',
      sectionId: 'Vivi la città',
      link: 'news',
      id: 'news'
    },
    {
      name: 'Eventi',
      icon: 'event',
      profile: 'all',
      sectionId: 'Vivi la città',
      link: 'tabs/events',
      id: 'events'
    },
    {
      name: 'Meteo',
      icon: 'thermostat',
      profile: 'all',
      sectionId: 'Vivi la città',
      link: 'weather',
      id: 'meteo'
    },
   /* {
      name: 'Rubrica',
      sectionId: 'Vivi la città',
      icon: 'add_call',
      link: 'address-book',
      id: 'rubrica'
    },*/
    {
      name: 'Annunci_lavorativi',
      profile: 'cittadino',
      sectionId: 'Opportunità',
      icon: 'work',
      link: 'jobs',
      id: 'jobs'
    },
    {
      name: 'Annunci_immobiliari',
      profile: 'cittadino',
      sectionId: 'Opportunità',
      icon: 'house',
      link: 'houses',
      id: 'houses'
    },

    {
      name: 'Impostazioni',
      profile: 'all',
      sectionId: 'App e supporto',
      icon: 'settings',
      link: 'settings',
      id: 'settings'
    },
    {
      name: 'Il nostro progetto',
      profile: 'all',
      sectionId: 'App e supporto',
      icon: 'assignment',
      link: 'project',
      id: 'project'
    },
    {
      name: 'Contattaci',
      profile: 'all',
      sectionId: 'App e supporto',
      icon: 'chat',
      link: 'contatct',
      id: 'contact'
    }
  ];
